import { ScaniaUnit, ScaniaUnitComponentType } from 'src/state';

export interface ScaniaUnitAllocation {
    id: number;
    scaniaUnitComponentTypeId: string;
    allocationScaniaUnitId: boolean;
    scaniaUnitComponentType: ScaniaUnitComponentType;
    allocationScaniaUnit : ScaniaUnit
}
